module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm_title1",
    attrs: {
      "id": "time"
    }
  }, [_vm._v("TIMELINE")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("30 Jan 1933")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Hitler becomes Reichskanzler of Germany")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12 Mar 1938")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anschluß")]), _vm._v(" – Hitler annexes Austria")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mar 1938")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Foreign Office set up Elektra House (EH) propaganda unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Apr 1938")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("SIS ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Glossary#rgloss_69",
      "id": "gloss_69"
    }
  }, [_vm._v("MI6")]), _vm._v(") creates Section D")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("c")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(". Oct 1938")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("GS(R) – later renamed MI(R) – created in War Office")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Sep 1939")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Germany invades Poland")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1 Sep 1939")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Section D moves to Frythe, near Welwyn, Hertfordshire")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Apr–Jun 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Independent Companies under Colin Gubbins operate in Norway")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10 May 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Winston Churchill becomes Prime Minister")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("May 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("British Security Coordination office established in New York")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("22 Jun 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("France surrenders")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jun–Jul 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("‘Wild Bill’ Donovan’s first survey trip to Britain")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jul 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("First meeting between ‘Intrepid’ and ‘Wild Bill’")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jul 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("General Headquarters Auxiliary Units created for UK Home Defence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("22 Jul 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("SOE Charter approved, formed from Section D, MI(R) and EH")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("28 Aug 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Sir Frank Nelson appointed ‘CD’ – head of SOE")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Oct 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Italy invades Crete, Germany follows in April 1941")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Nov 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Gubbins returns to SOE as Director of Training and Operations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dec 1940")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Donovan begins second trip to Britain, Mediterranean and Balkans; returns February 1941")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5 May 1941")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("First successful SOE infiltration into France; George Bégué sets up circuit and meets follow-on agents")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("20 May 1941")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Germany invades Crete")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11 Jul 1941")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Creation of COI")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 Dec 1941")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Camp X (STS 103) opens in Canada")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7 Dec 1941")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Japan attacks Pearl Harbor")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15 Feb 1942")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Singapore falls to the Japanese")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mar 1942")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Charles Jocelyn Hambro replaces Nelson as CD")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("13 Jun 1942")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("OSS replaces COI, placed under JCS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("23 Oct 1942")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Second battle of El Alamein")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8 Nov 1942")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torch")]), _vm._v(" – the Allied invasion of North Africa – begins")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dec 1942")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("First successful OSS infiltration into Europe (Corsica)")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 Sep 1943")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Allies invade Italy, Italy surrenders")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sep 1943")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Gubbins becomes director of SOE")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5/6 Jun 1944")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("1st JEDBURGH teams dropped into France")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 Jun 1944")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Overlord")]), _vm._v(", the invasion of Normandy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15 Aug 1944")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dragoon")]), _vm._v(", the invasion of southern France")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("17 Sep 1944")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Market Garden")]), _vm._v(" begins")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7 May 1945")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Germany surrenders")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 Sep 1945")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Japan surrenders")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("20 Sep 1945")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Executive Order 9621 abolishes the OSS")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15 Jan 1946")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("SOE dissolved by Prime Minister Clement Attlee")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("22 Jan 1946")])]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("President Truman directs establishment of Central Intelligence Group, forerunner of the CIA")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65857c59","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Timeline.vue
// module id = 75
// module chunks = 0